import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { observer, inject } from 'mobx-react'
import reactTriggerChange from 'react-trigger-change'
import { Link } from 'react-router'
import Icon from '../../../shared/components/Icon'
import getPath from '../../../shared/utils/getPath'

class StarRating
  extends Component {

  static defaultProps = {
    min: 1,
    max: 5,
    value: 0,
  }

  static propTypes = {
    className: PropTypes.string,
    id: PropTypes.string,
    max: PropTypes.number,
    min: PropTypes.number,
    name: PropTypes.string,
    value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  }

  handleSetValue(num) {
    if (this.$input) {
      this.$input.value = this.$input.value * 1 === num ? 0 : num
      reactTriggerChange(this.$input)
    }
  }

  renderStars() {
    const stars = []
    for (let i = 1; i <= this.props.max; i += 1) {
      stars.push(<span
        key={i}
        // eslint-disable-next-line
        onClick={this.handleSetValue.bind(this, i)}
        style={{ display: 'inline-block', position: 'relative', cursor: 'pointer' }}
      >
        <Icon
          name="star"
          size={30}
          style={{ fill: i <= this.props.value ? 'orange' : 'grey' }}
        />
      </span>)
    }
    return stars
  }

  render() {

    return (
      <span>
        <input
          {...this.props}
          style={{ display: 'none' }}
          step="1"
          type="number"
          ref={(input) => {
            this.$input = input
            return input
          }}
        />
        {this.renderStars()}
      </span>
    )
  }

}

@inject('rating') @observer
export default
class RatePage
  extends Component {

  static propTypes = {
    data: PropTypes.object.isRequired,
    isTeacher: PropTypes.bool,
    museum: PropTypes.object.isRequired,
  }

  /* eslint-disable max-len */

  renderPupilQuestions() {
    return (
      <div>
        <div>
          <label>
            <input type="checkbox"
              id="rating-way-of-discovery-teacher"
              name="rating-way-of-discovery.teacher"
              checked={this.props.data.wayOfDiscovery.teacher}
            />
            <span>Mein Lehrer hat davon erzählt.</span>
          </label>
        </div>
        <div>
          <label>
            <input type="checkbox"
              id="rating-way-of-discovery-musbi"
              name="rating-way-of-discovery.musbi"
              checked={this.props.data.wayOfDiscovery.musbi}
            />
            <span>Ich habe das Programm auf musbi.de entdeckt.</span>
          </label>
        </div>
        <div>
          <label>
            <input type="checkbox"
              id="rating-way-of-discovery-homepageMusem"
              name="rating-way-of-discovery.homepageMusem"
              checked={this.props.data.wayOfDiscovery.homepageMusem}
            />
            <span>Über die Homepage des Museums.</span>
          </label>
        </div>
        <div>
          <label>
            <input type="checkbox"
              id="rating-way-of-discovery-flyerMusem"
              name="rating-way-of-discovery.flyerMusem"
              checked={this.props.data.wayOfDiscovery.flyerMusem}
            />
            <span>Ich habe einen Flyer des Museums der Lehrkraft gegeben.</span>
          </label>
        </div>
        <div>
          <label>
            <input type="checkbox"
              id="rating-way-of-discovery-press"
              name="rating-way-of-discovery.press"
              checked={this.props.data.wayOfDiscovery.press}
            />
            <span>Ich habe einen Zeitungsartikel über das Programm der Lehrkraft gegeben.</span>
          </label>
        </div>
      </div>
    )
  }

  renderTeacherQuestions() {
    return (
      <div>
        <div>
          <label>
            <input type="checkbox"
              id="rating-way-of-discovery-collegue"
              name="rating-way-of-discovery.collegue"
              checked={this.props.data.wayOfDiscovery.collegue}
            />
            <span>Tipp von Kollegen.</span>
          </label>
        </div>
        <div>
          <label>
            <input type="checkbox"
              id="rating-way-of-discovery-musbi"
              name="rating-way-of-discovery.musbi"
              checked={this.props.data.wayOfDiscovery.musbi}
            />
            <span>Über musbi.de.</span>
          </label>
        </div>
        <div>
          <label>
            <input type="checkbox"
              id="rating-way-of-discovery-homepageMusem"
              name="rating-way-of-discovery.homepageMusem"
              checked={this.props.data.wayOfDiscovery.homepageMusem}
            />
            <span>Homepage des Museums.</span>
          </label>
        </div>
        <div>
          <label>
            <input type="checkbox"
              id="rating-way-of-discovery-flyerMusem"
              name="rating-way-of-discovery.flyerMusem"
              checked={this.props.data.wayOfDiscovery.flyerMusem}
            />
            <span>Flyer des Museums.</span>
          </label>
        </div>
        <div>
          <label>
            <input type="checkbox"
              id="rating-way-of-discovery-press"
              name="rating-way-of-discovery.press"
              checked={this.props.data.wayOfDiscovery.press}
            />
            <span>Tipp von Kollegen.</span>
          </label>
        </div>
      </div>
    )
  }

  render() {

    const { museum, museum: { programs, guidedTours }, isTeacher } = this.props

    /* eslint-disable max-len */
    return (
      <div>

        <input
          type="hidden"
          name="rating-is-teacher"
          value={isTeacher}
        />

        <div className="form-group form-group-offering-id">
          <label
            className="col-xs-12 col-md-6"
            htmlFor="rating-offering-id"
          >
            Ich habe im Museum
            {' '}
            <strong>{museum.name}</strong>
            {' '}
            an folgendem Angebot teilgenommen
          </label>
          <div className="col-xs-12 col-md-6">
            <select
              autoFocus
              className="form-control"
              id="rating-offering-id"
              name="rating-offering-id"
              value={this.props.data.programId}
            >
              <option value="-1">Angebot auswählen</option>
              {programs.map((program) => {
                return <option key={`p${program.id}`} value={`p${program.id}`}>{program.title}</option>
              })}
              {guidedTours.map((guidedTour) => {
                return <option key={`g${guidedTour.id}`} value={`g${guidedTour.id}`}>{guidedTour.title}</option>
              })}
            </select>
          </div>
        </div>

        <h4>1. Angaben zur Person</h4>

        <p>
          Möchten Sie automatisch an unserer Verlosung teilnehmen, geben Sie bitte Ihren Namen sowie Ihre Anschrift an. Ihr Name wird weder mit Ihrer Bewertung in Verbindung gesetzt noch auf auf musbi.de angezeigt. Die Bewertung ist völlig anonym. Angaben zu Ihrer Person werden nicht an Dritte weitergegeben.
          Bitte akzeptieren Sie unsere Teilnahmebedingungen, um an der Verlosung teilzunehmen.
        </p>

        <div className="form-group">
          <label className="hidden-xs col-sm-4" />
          <div className="col-xs-12 col-sm-8">
            <label>
              <input
                type="checkbox"
                id="rating-participate"
                name="rating-participate"
                checked={this.props.data.participate}
              />
              <span>
                Ja, ich akzeptiere die
                {' '}
                <a href="/static/files/Teilnahmebedingungen.pdf">Teilnahmebedingungen</a>
                {' '}
                und möchte an der Verlosung teilnehmen.
              </span>
            </label>
          </div>
        </div>

        <div className="form-group">
          <label className="hidden-xs col-sm-4" />
          <div className="col-xs-12 col-sm-8">
            <label>
              <input
                type="checkbox"
                id="rating-acceptDataUsage"
                name="rating-acceptDataUsage"
                checked={this.props.data.acceptDataUsage}
              />
              <span>
                Sie erklären sich damit einverstanden, dass Ihre Daten zur Bearbeitung Ihres Anliegens verwendet werden. Weitere Informationen und Widerrufshinweise finden Sie in der
                {' '}
                <Link target="_blank" to={getPath('frontend', 'dsgvo')}>Datenschutzerklärung</Link>
                .
              </span>
            </label>
          </div>
        </div>

        <div className="form-group">
          <label
            className="col-sm-4 col-xs-12"
            htmlFor="rating-firstname"
          >
            Vorname:
          </label>
          <div className="col-sm-8 col-xs-12">
            <input
              value={this.props.data.userFirstname}
              required
              type="text"
              className="form-control input-sm"
              id="rating-firstname"
              name="userFirstname"
            />
          </div>
        </div>

        <div className="form-group">
          <label
            className="col-xs-12 col-sm-4"
            htmlFor="rating-lastname"
          >
            Nachname:
          </label>
          <div className="col-xs-12 col-sm-8">
            <input
              value={this.props.data.userLastname}
              required
              type="text"
              className="form-control input-sm"
              id="rating-lastname"
              name="userLastname"
            />
          </div>
        </div>

        <div className="form-group">
          <label
            className="col-xs-12 col-sm-4"
            htmlFor="rating-street"
          >
            Straße:
            <small>(optional)</small>
          </label>
          <div className="col-xs-12 col-sm-8">
            <input
              value={this.props.data.userStreet}
              type="text"
              className="form-control input-sm"
              id="rating-street"
              name="userStreet"
            />
          </div>
        </div>

        <div className="form-group">
          <label
            className="hidden-xs col-sm-4"
            htmlFor="rating-zip"
          >
            PLZ / Wohnort:
            <small>(optional)</small>
          </label>
          <label
            className="col-xs-12 hidden-sm hidden-md hidden-lg"
            htmlFor="rating-zip"
          >
            PLZ:
            <small>(optional)</small>
          </label>
          <div className="col-xs-12 col-sm-3">
            <input
              value={this.props.data.userZip}
              type="text"
              className="form-control input-sm"
              id="rating-zip"
              name="userZip"
            />
          </div>
          <label
            className="col-xs-12 hidden-sm hidden-md hidden-lg"
            htmlFor="rating-zip"
          >
            Ort:
            <small>(optional)</small>
          </label>
          <div className="col-xs-12 col-sm-5">
            <input
              value={this.props.data.userLocation}
              type="text"
              className="form-control input-sm"
              id="rating-location"
              name="userLocation"
            />
          </div>
        </div>

        <div className="form-group">
          <label
            className="col-xs-12 col-sm-4"
            htmlFor="rating-school"
          >
            Schule:
          </label>
          <div className="col-xs-12 col-sm-8">
            <input
              value={this.props.data.school}
              type="text"
              className="form-control input-sm"
              id="rating-school"
              name="school"
            />
          </div>
        </div>

        <h4>
          <span className="count">2. </span>
          {isTeacher
            ? 'Wie hat Ihnen und den Schülern das Programm bzw. die Themenführung insgesamt gefallen?'
            : 'Wie hat Dir das Programm bzw. die Themenführung gefallen?'}
        </h4>
        <div className="form-group">
          <div className="col-xs-12 col-md-12">
            <StarRating
              id="rating-overall-impression"
              name="rating-overall-impression"
              className="rating"
              max={5}
              value={this.props.data.overallImpression}
            />
          </div>
        </div>

        <h4>
          <span className="count">3. </span>
          {isTeacher
            ? 'Wie fanden Sie die didaktisch-methodische Aufbereitung des Inhalts?'
            : 'Wie abwechslungsreich war das Programm bzw. die Themenführung?'}
        </h4>
        <div className="form-group">
          <div className="col-xs-12 col-md-12">
            <StarRating
              id="rating-didactically"
              name="rating-didactically"
              className="rating"
              max={5}
              value={this.props.data.didactically}
            />
          </div>
        </div>

        <h4>
          <span className="count">4. </span>
          {isTeacher
            ? 'Wie fanden Sie die Vortragsart des museumspädagogischen Personals?'
            : 'Wie hat die Führungskraft den Inhalt rübergebracht?'}
        </h4>
        <div className="form-group">
          <div className="col-xs-12 col-md-12">
            <StarRating
              id="rating-presentation"
              name="rating-presentation"
              className="rating"
              max={5}
              value={this.props.data.presentation}
            />
          </div>
        </div>

        <h4>
          <span className="count">5. </span>
          {isTeacher
            ? 'Wie empfanden Sie die räumlichen Voraussetzungen für das museumspädagogische Programm bzw. die Themenführung?'
            : 'Wie ausreichend war der Platz, den Du mit deiner Klasse im Museum hattest?'}
        </h4>
        <div className="form-group">
          <div className="col-xs-12 col-md-12">
            <StarRating
              id="rating-spacial"
              name="rating-spacial"
              className="rating"
              max={5}
              value={this.props.data.spacial}
            />
          </div>
        </div>

        <h4>
          <span className="count">6. </span>
          {isTeacher
            ? 'Bitte bewerten Sie den Gewinn der Veranstaltung.'
            : 'Hat Dir die Veranstaltung was gebracht?'}
        </h4>
        <div className="form-group">
          <div className="col-xs-12 col-md-12">
            <StarRating
              id="rating-win"
              name="rating-win"
              className="rating"
              max={5}
              value={this.props.data.win}
            />
          </div>
        </div>

        <h4>
          <span className="count">7. </span>
          {isTeacher
            ? 'Werden Sie das Programm bzw. die Themenführung weiterempfehlen?'
            : 'Kannst Du das Programm bzw. die Themenführung weiterempfehlen?'}
        </h4>
        <div
          id="rating-recommendation-rate"
          className="form-group"
        >
          <div className="col-xs-12 col-md-12">
            <div className="radio">
              <label>
                <input
                  name="rating-recommendation-rate"
                  value="1"
                  type="radio"
                  checked={this.props.data.recommendationRate * 1 === 1}
                />
                <span>ja</span>
              </label>
            </div>
            <div className="radio">
              <label>
                <input
                  name="rating-recommendation-rate"
                  value="0"
                  type="radio"
                  checked={this.props.data.recommendationRate * 1 === 0}
                />
                <span>nein</span>
              </label>
            </div>
          </div>
        </div>

        <h4>
          <span className="count">8. </span>
          {isTeacher
            ? 'Wie sind Sie auf das Programm bzw. die Themenführung aufmerksam geworden?'
            : 'Wie hast Du von dem Programm bzw. der Themenführung erfahren?'}
        </h4>

        {isTeacher
          ? this.renderTeacherQuestions()
          : this.renderPupilQuestions()}

        <h4>
          <span className="count">9. </span>
          {' '}
          Kommentar (optional, nur für Administartor sichtbar)
        </h4>
        <div className="form-group">
          <div className="col-md-8 col-xs-12">
            <textarea
              rows="6"
              className="form-control"
              id="rating-comment"
              name="rating-comment"
              value={this.props.data.comment}
            />
          </div>
        </div>

      </div>
    )
    /* eslint-enable max-len */
  }
}



// WEBPACK FOOTER //
// ./src/frontend/rating/components/RateForm.js